export default "__VITE_ASSET__Bgq3tIeg__"